/**
 * Vue syntetic
 */

import { HistoricDataColor } from './data';

export interface CrtFavorite {
  type: CrtFavoriteType;
  identifiant?: number;
  ordre: number;
  idDonnee?: number;
  idGroupe?: number;
  historiques?: HistoricDataColor[];
  description?: string;
  idSite?: string;
}

export enum CrtFavoriteType {
  HISTO = 'HISTO',
  DONNEE = 'DONNEE',
  GROUPE = 'GROUPE',
  ALARM = 'ALARM',
}
